<script>
  import { onMount } from 'svelte';
  import { Router, Link, Route } from "svelte-routing";
  import DashboardRedirect from "./DashboardRedirect.svelte";
  import Timer from "./Timer.svelte";
  import Setup from "./Setup.svelte";

  export let url = "";

  // Pas de document.title aan op basis van de URL-parameter
  onMount(() => {
    const style = new URLSearchParams(location.search).get('style');
    if (style) {
      document.title = `Savona Dashboard - ${style}`;
    } else {
      document.title = 'Savona Dashboard';
    }
  });
</script>

<!-- App.svelte -->
<Router {url} basepath="/svelte-ui">
  <div>
    <Route path="/">
      <Timer />
    </Route>
    <Route path="/dashboard" component={DashboardRedirect} />
    <Route path="/setup" component={Setup} />
  </div>
</Router>
